import React from 'react';
import { publications } from '../@publications/data';

export default function Publications() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">研究成果</h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
          </p>
        </div>

        {/* 文章列表 */}
        <div className="mx-auto mt-10 space-y-8 sm:mt-16">
          {publications.map((pub) => (
            <article key={pub.id} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow h-[320px]">
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 h-full">
                <div className="w-full sm:w-64 h-48 sm:h-full flex-shrink-0">
                  <img 
                    loading="lazy"
                    src={pub.image} 
                    alt={pub.title}
                    className="w-full h-full object-cover rounded-lg"
                  />
                </div>
                <div className="flex-1 overflow-hidden flex flex-col">
                  <div className="flex gap-2 mb-3">
                    <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                      {pub.type}
                    </span>
                    <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                      {pub.impact}
                    </span>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 line-clamp-2">{pub.title}</h3>
                  <p className="mt-2 text-sm text-gray-600">{pub.authors.join(', ')}</p>
                  <p className="mt-1 text-sm text-gray-600">
                    <span className="font-medium">{pub.journal}</span>, {pub.year}
                  </p>
                  <p className="mt-3 text-sm text-gray-600 line-clamp-3">{pub.abstract}</p>
                  <div className="mt-auto pt-4">
                    <a 
                      href={pub.paperUrl}
                      target="_blank"
                      rel="noopener noreferrer" 
                      className="inline-flex items-center rounded-md bg-indigo-50 px-3 py-2 text-sm font-semibold text-indigo-600 shadow-sm hover:bg-indigo-100"
                    >
                      阅读论文
                      <svg className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}